import React from 'react';
import { useTranslation } from 'react-i18next';

/** Цвета Пожарной сигнализации: не подключена / в работе / не готова / недоступна / В огне. */
export const FIRE_PANEL_STATE = {
  NOT_CONNECTED: 'not_connected',
  OK: 'ok',
  FAULT: 'fault',
  UNAVAILABLE: 'unavailable',
  ON_FIRE: 'on_fire',
};

const STATE_STYLE = {
  [FIRE_PANEL_STATE.NOT_CONNECTED]: {
    icon: 'text-muted-500',
    ring: 'border-muted-600/50 bg-muted-700/20',
    label: 'text-muted-400',
    glow: '',
  },
  [FIRE_PANEL_STATE.OK]: {
    icon: 'text-positive',
    ring: 'border-positive/40 bg-positive/10',
    label: 'text-positive',
    glow: 'shadow-[0_0_10px_rgba(34,197,94,0.12)]',
  },
  [FIRE_PANEL_STATE.FAULT]: {
    icon: 'text-warning',
    ring: 'border-warning/40 bg-warning/10',
    label: 'text-warning',
    glow: 'shadow-[0_0_10px_rgba(234,179,8,0.1)]',
  },
  [FIRE_PANEL_STATE.UNAVAILABLE]: {
    icon: 'text-critical',
    ring: 'border-critical/50 bg-critical/15',
    label: 'text-critical',
    glow: '',
  },
  [FIRE_PANEL_STATE.ON_FIRE]: {
    icon: 'text-critical',
    ring: 'border-critical/50 bg-critical/15',
    label: 'text-critical',
    glow: 'shadow-[0_0_12px_rgba(239,68,68,0.18)] animate-pulse',
  },
};

const SIZE = {
  md: { box: 'h-14 w-14', icon: 'text-3xl', label: 'text-[10px]' },
  lg: { box: 'h-24 w-24', icon: 'text-6xl', label: 'text-xs' },
  xl: { box: 'h-28 w-28', icon: 'text-7xl', label: 'text-sm' },
};

/**
 * Крупный значок огня со состоянием Пожарного прибора.
 * @param {{ state?: string, size?: 'md'|'lg'|'xl', showLabel?: boolean, className?: string }} props
 */
const FirePanelStatusIcon = ({
  state = FIRE_PANEL_STATE.NOT_CONNECTED,
  size = 'lg',
  showLabel = true,
  className = '',
}) => {
  const { t } = useTranslation();
  const resolved = STATE_STYLE[state] ? state : FIRE_PANEL_STATE.NOT_CONNECTED;
  const style = STATE_STYLE[resolved];
  const dim = SIZE[size] || SIZE.lg;
  const title = t(`fire.panel.tooltip.${resolved}`);
  const label = t(`fire.panel.state.${resolved}`);

  return (
    <div
      className={`inline-flex flex-col items-center gap-1.5 ${className}`}
      title={title}
      aria-label={title}
    >
      <div
        className={`flex items-center justify-center rounded-3xl border ${dim.box} ${style.ring} ${style.glow}`}
      >
        <span className={`material-icons ${dim.icon} ${style.icon}`}>local_fire_department</span>
      </div>
      {showLabel && (
        <span className={`max-w-[9rem] text-center font-semibold uppercase tracking-[0.12em] ${dim.label} ${style.label}`}>
          {label}
        </span>
      )}
    </div>
  );
};

export default FirePanelStatusIcon;
